import type { RailwayService, RailwaySession } from '@cli-types/next-adapter/railway.js'
import { delay } from '@cli-utils/shared.js'
import { readRailwayServiceVariables } from './read-railway-service-variables.js'

export async function waitForPostgresVariables(
  session: RailwaySession,
  cwd: string,
  service: RailwayService
): Promise<Record<string, string>> {
  for (let attempt = 0; attempt < 20; attempt++) {
    const variables = await readRailwayServiceVariables(session, cwd, service.name)
    if (variables.DATABASE_PUBLIC_URL && variables.DATABASE_URL) return variables
    if (attempt < 19) await delay(1_500)
  }
  return {}
}
